import { OperatorSalesCommissionRepPage } from "@/components/non_registrant/operator-sales-commission";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/operator/overview_/sales-commission/$repId",
)({
  component: SalesCommissionRepRoute,
});

function SalesCommissionRepRoute() {
  const { repId } = Route.useParams();
  return <OperatorSalesCommissionRepPage repId={repId} />;
}
